import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat';
import weekday from 'dayjs/plugin/weekday';
import "dayjs/locale/zh-cn";

dayjs.extend(weekday);
dayjs.extend(customParseFormat);
dayjs.locale('zh-cn')

export default dayjs 